import { repo } from '../services/repository'
import type { GameStatePayload } from '../types/auth'
import type { Item } from '../components/types'

/** 兼容旧调用方的蛇形字段形态 */
export interface GameStateData {
  mode: string
  current_level: number
  total_score: number
  current_score: number
  highest_number: number
  is_level_completed: boolean
  moves: number
  tools: Item[]
  language: string
  diamonds: number
  sound_on: boolean
}

function toLegacy(payload: GameStatePayload): GameStateData {
  return {
    mode: payload.mode,
    current_level: payload.currentLevel,
    total_score: payload.totalScore,
    current_score: payload.currentScore,
    highest_number: payload.highestNumber,
    is_level_completed: payload.isLevelCompleted,
    moves: payload.moves,
    tools: (payload.tools as Item[]) || [],
    language: payload.language,
    diamonds: payload.diamonds,
    sound_on: payload.soundOn,
  }
}

function fromLegacy(data: GameStateData): GameStatePayload {
  return {
    mode: data.mode,
    currentLevel: data.current_level,
    totalScore: data.total_score,
    currentScore: data.current_score,
    highestNumber: data.highest_number,
    isLevelCompleted: data.is_level_completed,
    moves: data.moves,
    tools: data.tools,
    language: data.language,
    diamonds: data.diamonds,
    soundOn: data.sound_on,
  }
}

/**
 * 游戏状态服务 — 通过 Repository 访问 Mock / API
 */
class GameStateService {
  public async fetchGameState(): Promise<GameStateData | null> {
    try {
      const payload = await repo.gameState.get()
      return payload ? toLegacy(payload) : null
    } catch (error) {
      console.error('GameStateService: 获取游戏状态出错:', error)
      return null
    }
  }

  public async updateGameState(gameState: GameStateData): Promise<GameStateData | null> {
    try {
      const payload = await repo.gameState.put(fromLegacy(gameState))
      return payload ? toLegacy(payload) : null
    } catch (error) {
      console.error('GameStateService: 更新游戏状态出错:', error)
      return null
    }
  }
}

export const gameStateService = new GameStateService()
export default gameStateService
